import type { FC } from "react";

import { Paper, ScrollArea, Stack, Text } from "@mantine/core";

import type { EvaluationDetailsBody } from "../../api/evaluations/types";

import { BehaviorsChecklist } from "./BehaviorsChecklist";

export interface EvaluationBehaviorsListProps {
    /** The behaviors from the evaluation results (`EvaluationDetails.Body`), in order. Indices align with the page's `activeBehaviorIndex`. */
    behaviors: EvaluationDetailsBody[];
    activeBehaviorIndex: number;
    onClickBehavior?: (index: number) => void;
}

/**
 * ASCEND side panel: the "Assessment Results" behaviors panel for the evaluation page. Wraps the shared
 * `BehaviorsChecklist` rows in a Paper + scroll area; selecting a row reports its index up so the page
 * can point the callout at that behavior and jump the transcript to its first line.
 */
export const EvaluationBehaviorsList: FC<EvaluationBehaviorsListProps> = ({
    behaviors,
    activeBehaviorIndex,
    onClickBehavior,
}) => {
    return (
        <Paper
            display="flex"
            shadow="md"
            radius="md"
            p="1rem"
            w="100%"
            bg="var(--mantine-color-dark-5)"
            bdrs="0.75rem"
            flex="1"
            style={{
                flexDirection: "column",
                maxHeight: "100%",
            }}
        >
            <ScrollArea offsetScrollbars scrollbarSize={8} type="hover" flex="1">
                <Stack gap={0}>
                    <Stack gap="0.25rem" px="xs" mb="1rem">
                        <Text fw={700} size="md" c="var(--mantine-color-gray-0)">
                            Assessment Results
                        </Text>
                    </Stack>
                    <BehaviorsChecklist
                        behaviors={behaviors}
                        activeBehaviorIndex={activeBehaviorIndex}
                        onClickBehavior={onClickBehavior}
                    />
                </Stack>
            </ScrollArea>
        </Paper>
    );
};

export default EvaluationBehaviorsList;
